import React from "react";

import {mb} from "@pg-design/helpers-css";
import {Tabs} from "@pg-design/tabs";

import {useTravelTimeTabs} from "../../hooks/use_travel_time_tabs";
import {TravelTabsType} from "../../types/TravelTabsType";
import {ResultWitchTravelTimeWrapper} from "../SearchFormWithDrawer";
import {TimeTravelSelects} from "../TimeTravelSelects";
import {IDropdownListOwnProps, SearchAutocompleteDropdown} from "./SearchAutocompleteDropdown";

export type ISearchAutocompleteDropdownWithTimeTravelProps = {
    isInModal?: boolean;
    onSearchSubmit: () => void;
    onTravelTimeCancel: () => void;
    travelTimeTabChangeHandler: (tab: TravelTabsType) => void;
} & ReturnType<typeof useTravelTimeTabs>;

type IOwnProps = IDropdownListOwnProps;

export const SearchAutocompleteDropdownWithTimeTravel = (props: ISearchAutocompleteDropdownWithTimeTravelProps & IOwnProps) => {
    const {isInModal, activeTravelTimeTab, travelTimeTabs, travelTimeTabChangeHandler, onSearchSubmit, onTravelTimeCancel} = props;
    const isTravelTabActive = activeTravelTimeTab === TravelTabsType.TRAVEL_TIME;

    return (
        <ResultWitchTravelTimeWrapper>
            {!isInModal && (
                <Tabs
                    activeColor="full-dark"
                    onChange={travelTimeTabChangeHandler}
                    color="gray"
                    tabs={travelTimeTabs}
                    value={activeTravelTimeTab}
                    variant="line"
                    fullWidth
                    css={mb(3)}
                />
            )}
            <SearchAutocompleteDropdown
                dropdownIsOpen={props.dropdownIsOpen}
                search={props.search}
                selectedTab={props.selectedTab}
                onLinkClick={props.onLinkClick}
                requestStateObj={props.requestStateObj}
                activeItem={props.activeItem}
                offers={props.offers}
                places={props.places}
                regions={props.regions}
                removeRegionTag={props.removeRegionTag}
                vendors={props.vendors}
                useTravelTime={isTravelTabActive}
            />
            {isTravelTabActive && (
                <TimeTravelSelects
                    isActive={props.isSearchButtonActive}
                    onClose={() => {
                        props.onClose?.();
                    }}
                    getFieldProps={props.getFieldProps}
                    onSubmit={onSearchSubmit}
                    updateTravelTimeState={props.setTravelTimeData}
                    prevDistance={props.prevDistance}
                    onCancel={onTravelTimeCancel}
                    placesArrayNotEmpty={props.places.length > 0}
                    isInModal={isInModal}
                />
            )}
        </ResultWitchTravelTimeWrapper>
    );
};
import React from "react";

import {mb} from "@pg-design/helpers-css";
import {Tabs} from "@pg-design/tabs";

import {useTravelTimeTabs} from "../../hooks/use_travel_time_tabs";
import {TravelTabsType} from "../../types/TravelTabsType";
import {ResultWitchTravelTimeWrapper} from "../SearchFormWithDrawer";
import {TimeTravelSelects} from "../TimeTravelSelects";
import {IDropdownListOwnProps, SearchAutocompleteDropdown} from "./SearchAutocompleteDropdown";

export type ISearchAutocompleteDropdownWithTimeTravelProps = {
    isInModal?: boolean;
    onSearchSubmit: () => void;
    onTravelTimeCancel: () => void;
    travelTimeTabChangeHandler: (tab: TravelTabsType) => void;
} & ReturnType<typeof useTravelTimeTabs>;

type IOwnProps = IDropdownListOwnProps;

export const SearchAutocompleteDropdownWithTimeTravel = (props: ISearchAutocompleteDropdownWithTimeTravelProps & IOwnProps) => {
    const {isInModal, activeTravelTimeTab, travelTimeTabs, travelTimeTabChangeHandler, onSearchSubmit, onTravelTimeCancel} = props;
    const isTravelTabActive = activeTravelTimeTab === TravelTabsType.TRAVEL_TIME;

    return (
        <ResultWitchTravelTimeWrapper>
            {!isInModal && (
                <Tabs
                    activeColor="full-dark"
                    onChange={travelTimeTabChangeHandler}
                    color="gray"
                    tabs={travelTimeTabs}
                    value={activeTravelTimeTab}
                    variant="line"
                    fullWidth
                    css={mb(3)}
                />
            )}
            <SearchAutocompleteDropdown
                dropdownIsOpen={props.dropdownIsOpen}
                search={props.search}
                selectedTab={props.selectedTab}
                onLinkClick={props.onLinkClick}
                requestStateObj={props.requestStateObj}
                activeItem={props.activeItem}
                offers={props.offers}
                places={props.places}
                regions={props.regions}
                removeRegionTag={props.removeRegionTag}
                vendors={props.vendors}
                useTravelTime={isTravelTabActive}
            />
            {isTravelTabActive && (
                <TimeTravelSelects
                    isActive={props.isSearchButtonActive}
                    onClose={() => {
                        props.onClose?.();
                    }}
                    getFieldProps={props.getFieldProps}
                    onSubmit={onSearchSubmit}
                    updateTravelTimeState={props.setTravelTimeData}
                    prevDistance={props.prevDistance}
                    onCancel={onTravelTimeCancel}
                    placesArrayNotEmpty={props.places.length > 0}
                    isInModal={isInModal}
                />
            )}
        </ResultWitchTravelTimeWrapper>
    );
};
